export const ResultTypeEnum = Object.freeze({
	RAW: 'RAW',
	PERCENT: 'PERCENT',
})
